import dagre from '@dagrejs/dagre';
import { Edge, Node } from '@xyflow/react';
import { TableNodeData } from './types';

export interface SizedNode {
    id: string;
    width: number;
    height: number;
}

/**
 * Left-to-right dagre layout. Edges point child -> parent (FK direction), so
 * parents settle to the right of the tables that reference them.
 */
export function layout(
    nodes: Node<TableNodeData>[],
    edges: Edge[],
): Node<TableNodeData>[] {
    const g = new dagre.graphlib.Graph();
    g.setGraph({ rankdir: 'LR', nodesep: 40, ranksep: 120, marginx: 20, marginy: 20 });
    g.setDefaultEdgeLabel(() => ({}));

    nodes.forEach((n) => {
        g.setNode(n.id, {
            width: n.width ?? 220,
            height: n.height ?? 80,
        });
    });
    edges.forEach((e) => g.setEdge(e.source, e.target));

    dagre.layout(g);

    return nodes.map((n) => {
        const pos = g.node(n.id);
        const w = n.width ?? 220;
        const h = n.height ?? 80;
        return {
            ...n,
            // dagre gives node centre; React Flow wants top-left.
            position: { x: pos.x - w / 2, y: pos.y - h / 2 },
        };
    });
}
